import { Skeleton, Shape, BaseProps } from '@teko/ds-desktop';
import React from 'react';

export const ProductPriceSkeleton = ({ ...rest }: BaseProps) => {
  return (
    <Shape {...rest}>
      {/* Add Skeleton when loading price. Ref: https://jira.teko.vn/browse/UX4BUYER-5684 */}
      <Skeleton width={120} height="1rem" marginBottom="s4" marginTop="s4" />
      <Skeleton width={80} height="1rem" />
    </Shape>
  );
};
